<template>
  <BaseModal :id="`modal-alert-${conflictType}`" :title="title" size="md" :hide-footer="true">
    <div class="body">
      <div>
        {{ description }}
      </div>
      <div class="font-weight-bold mt-4 font-18">{{ subTitle }}</div>
      <div
        v-for="(conflictListItem, index) in conflictList"
        :key="conflictListItem.section_id || index + 'conflict'"
        class="conflict-list__item py-3"
        :class="[index !== conflictList.length - 1 ? 'border-bottom' : '']"
      >
        <div class="conflict-list__item-title text-dark font-18">
          {{ conflictListItem.learning_unit.name }}
        </div>
        <div class="conflict-list__item-date-to-end text-dark mb-3">
          {{ conflictListItem.start_at }} - {{ conflictListItem.end_at }}
        </div>
        <div
          v-for="(date, dateIndex) in conflictListItem.dates"
          :key="dateIndex"
          class="conflict-list__item-date my-1"
        >
          {{ date }}
        </div>
      </div>
    </div>
    <template v-if="!hideFooter" name="modal-footer">
      <div class="pb-4">Click at the "Confirm" button to create this item.</div>

      <b-button variant="success" @click="handleConfirm">
        <span v-if="!isSubmitting">Confirm</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>

      <b-button variant="link" @click="hide"> Continue editing </b-button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal';
import { notificationMixin } from '@/mixins/notificationMixin';
import Section from '@/models/Section';

export default {
  name: 'ModalAlertConflict',

  components: { BaseModal },

  mixins: [notificationMixin],

  model: [Section],

  props: {
    pageType: {
      type: String,
      default: 'create'
    },
    conflictType: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      required: true
    },
    conflictList: {
      type: Array,
      default: () => []
    },
    hideFooter: {
      type: Boolean,
      default: true
    },
    form: {
      type: Object,
      default() {
        return {
          start_at: null,
          last_enrollment: null,
          end_at: null,
          max_learners: null,
          online_meeting_start_time: '09:00',
          selectedDays: ['Monday'],
          /* 1 = Does not repeat, 2 = Weekly, 3 = Biweekly */
          selectedRepeat: 1
        };
      }
    }
  },

  data() {
    return {
      isSubmitting: false
    };
  },

  methods: {
    async handleConfirm() {
      // this.isSubmitting = true;

      this.$emit('confirm');

      this.hide();
      // const { form } = this;
      // const formSubmit = {
      //   ...form,
      //   learning_unit: this.$route.params.learningUnitId,
      //   max_learners: +form.max_learners,
      //   online_meeting_start_time: moment(
      //     form.online_meeting_start_time,
      //     "LT"
      //   ).format("HH:mm:ss"),
      //   days_of_week: JSON.stringify(form.selectedDays),
      //   section_repeat: form.selectedRepeat,
      // };

      // try {
      //   if (this.$route.name.includes("create")) {
      //     await Section.api().createSection(formSubmit);
      //     this.finishedSectionAction("created");
      //   }
      //   if (this.$route.name.includes("edit")) {
      //     await Section.api().updateSection(
      //       this.$route.params.sectionId,
      //       formSubmit
      //     );
      //     this.finishedSectionAction("updated");
      //   }
      // } catch (error) {
      //   console.log(error);
      //   this.isSubmitting = false;
      //   this.notiError();
      // }
    },

    finishedSectionAction(action = '') {
      this.isSubmitting = false;
      // this.hide();
      this.notiSuccess('Section', action);
      this.goToInfoSectionPage();
    },

    goToInfoSectionPage() {
      this.$router.push({
        name: 'design-planning/info',
        params: {
          learningUnitId: this.$route.params.learningUnitId
        },
        query: {
          tab: 'sessions'
        }
      });
    },

    show() {
      this.$bvModal.show(`modal-alert-${this.conflictType}`);
    },
    hide() {
      this.$bvModal.hide(`modal-alert-${this.conflictType}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.font-18 {
  font-size: 18px !important;
}
</style>
